module.exports = __webpack_public_path__ + "static/media/QRcode3.e65c3c44.png";